import React from 'react';
import {SortingBtn} from 'components/lib/buttons/IconButtons';
import styles from 'styles/components/lib/tables/dnd/dndHeader.css';

const DNDHeader = props => (
  <ul className={styles.dndHeaderPrint}
    style={ props.groups ? { padding: '0px 30px 0px 20px' } : {}} >
      { props.columns.map((data, key) =>

        <DnDHeaderCell key={key}
                       data={data}
                       isEditing={props.isEditing}
                       isTouchDevice={props.isTouchDevice}
                       groups={props.groups}
                       onClick={!props.groups ? props.onClick : null}
                       packages={props.packages}  />
      )}
  </ul>
);

export default DNDHeader;

class DnDHeaderCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = { reverse: false, sortBy: ''};
    this.toggleState = this.toggleState.bind(this);
  }
  toggleState(data) {
    let reverse = !this.state.reverse
    this.setState({ reverse });
    this.props.onClick(data.accessor, reverse)
  }
  render() {
    let { data, groups, isTouchDevice } = this.props;
	  let maxWidth;

	  switch( data.grow ) {
		  case 0: maxWidth = `${data.width}px`;  break;
		  case 1: maxWidth = `10%`; break;
		  case 2: maxWidth = `20%`; break;
		  case 3: maxWidth = `30%`; break;
		  default:  maxWidth = `${data.width}px`; break;
	  }

    let style = {
      flex: `${ data.grow ? data.grow : 0} 0 ${data.width}px`,
      paddingTop: `${!groups && data.name === 'actions' ? '5px' : '0px'}`,
      maxWidth: maxWidth
    }
    let title = data.title ? data.title : '';
    let onClick = () => {
      let sortVal = (typeof data.accessor !== 'string') ? 'displayName' : data.accessor;
      if(this.state.sortBy === sortVal) {
        this.toggleState(data);
      } else {
        this.props.onClick(data.accessor);
        this.setState({ sortBy: sortVal })
      }
    }

    if (title === 'Ticket Type' && this.props.packages) title = 'Package Type';
    if (title === 'Ticket Type' && this.props.groups) title = "Group Name";
    if ((data.name === 'priceLevelSection' || data.name === 'promotionName') &&
      this.props.packages) return null;
    let className = data.name ?
      (!this.props.packages && data.name === 'quantity') ?
        styles.quantityTicketPrint
        : styles[data.name]
      : styles.dndHeaderCell;
    return (
      <li
        className={data.name ? className : styles.dndHeaderCell}
        onClick={this.props.onClick && data.name !== 'actions' && !this.props.isEditing ? onClick : null}
        style={style} >
        <h5 className={!groups && title !== 'Actions' ? styles.tickets : null}
            style={{cursor: `${groups || data.name === 'actions' ? 'default' : 'pointer'}`}}>{title}</h5>
        { (!groups && title !== 'Actions' && title !== '') &&
            <SortingBtn className={styles.printHidden} style={{height: '100%'}} />
        }
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DNDHeader.js